import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Scales = props => (
  <SvgIcon {...props} width="20.758" height="19.504" viewBox="0 0 20.758 19.504">
    <g id="scale" transform="translate(0 -15.469)">
      <path id="Path_7428" data-name="Path 7428" d="M37.066,20.266a.613.613,0,0,0-.338-.3l-4.5-1.638a1.825,1.825,0,0,0-3.263-1.188l-4.494-1.635h0a.613.613,0,0,0-.75.3L20.87,21.458h1.362l2.032-4.036,2.057,4.036h1.365L25.5,17.176l3.073,1.119a1.823,1.823,0,0,0,1.218,1.692V31.8a.608.608,0,1,0,1.216,0V19.987a1.812,1.812,0,0,0,.771-.526l3.89,1.416-2.56,5.086h1.362l2.049-4.071,2.051,4.071h1.362ZM30.834,18.7a.61.61,0,1,1,0-.863A.611.611,0,0,1,30.834,18.7Z" transform="translate(-20.024)" />
      <path id="Path_7429" data-name="Path 7429" d="M165.616,404.243h-1.432a3.137,3.137,0,0,0-3.134,3.133.608.608,0,0,0,.608.608h6.483a.608.608,0,0,0,.608-.608A3.137,3.137,0,0,0,165.616,404.243Z" transform="translate(-154.521 -373.012)" />
      <path id="Path_7430" data-name="Path 7430" d="M309.858,304.3h-7.3a.608.608,0,0,0-.608.608,4.258,4.258,0,1,0,8.516,0A.608.608,0,0,0,309.858,304.3Z" transform="translate(-289.708 -277.12)" />
      <path id="Path_7431" data-name="Path 7431" d="M7.91,193.2H.608a.608.608,0,0,0-.608.608,4.259,4.259,0,0,0,8.518,0A.608.608,0,0,0,7.91,193.2Z" transform="translate(0 -170.53)" />
    </g>
  </SvgIcon>

);

export default Scales;
